import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_2 = {
  key: 0,
  class: "form-error"
}
const _hoisted_3 = { class: "checkbox-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "fingerprint" }, "Use fingerprint", -1)
const _hoisted_5 = {
  key: 2,
  class: "modal-content"
}
const _hoisted_6 = {
  key: 3,
  class: "modal-footer"
}

import { callGenerateOfflineCertificate } from "@/api/offlineCertificate";
import { computed, reactive } from "vue";
import { VaInput, VaModal, VaButton, VaCheckbox } from "vuestic-ui";
import { useStore } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { useI18n } from "vue-i18n";
import CryptoJS from "crypto-js";
import ButtonClipboardCopy from "@/components/ButtonClipboardCopy.vue";


export default /*#__PURE__*/_defineComponent({
  emits: ["add"],
  setup(__props, { emit: $emit }) {

const AVAILABLE_PRODUCT = ["dts"];

const { t } = useI18n();

const store = useStore();



const state = reactive({
  isOpen: false,
  response: null,
  loading: false,
  form: {
    error: "",
    key: computed(() => store.state.licensing.entitlementEdit.license.key),
    isFingerprint: false,
    hostname: "",
    mac: "",
    fingerprint: ""
  }
});

const productId = computed(
  () => store.state.licensing.products[0].licenseSystemData.CryptlexProductId
);

const allowOfflineActivation = computed(() => {
  return AVAILABLE_PRODUCT.some(
    p => p === store.state.licensing.entitlement.productId
  );
});

const closeAndReset = () => {
  resetForm();
  state.isOpen = false;
};

const checkFormErrors = () => {
  if (!state.form.key) {
    state.form.error = t(
      "entitlements.addOfflineCertificateModal.form.errors.key"
    );
    return false;
  }

  if (!state.form.hostname) {
    state.form.error = t(
      "entitlements.addOfflineCertificateModal.form.errors.hostname"
    );
    return false;
  }

  if (!state.form.mac && !state.form.isFingerprint) {
    state.form.error = t(
      "entitlements.addOfflineCertificateModal.form.errors.mac"
    );
    return false;
  }
  if (state.form.isFingerprint && !state.form.fingerprint) {
    state.form.error = t(
      "entitlements.addOfflineCertificateModal.form.errors.fingerprint"
    );
    return false;
  }

  return true;
};

const fingerprint = computed(() => {
  const hash = state.form.isFingerprint
    ? state.form.fingerprint
    : CryptoJS.SHA256(state.form.hostname + state.form.mac).toString(
        CryptoJS.enc.Hex
      );

  return hash.trim();
});

const resetForm = () => {
  state.form.key = computed(
    () => store.state.licensing.entitlementEdit.license.key
  );
  state.form.isFingerprint = false;
  state.form.hostname = "";
  state.form.mac = "";
  state.form.fingerprint = "";
  state.form.error = "";
  state.response = null;
  state.loading = false;
};

const generateOfflineCertificate = async () => {
  if (!checkFormErrors()) {return;}

  state.form.error = "";
  state.loading = true;
  try {
    const payload = {
      productId: productId.value,
      licenseKey: state.form.key,
      hostName: state.form.hostname.trim(),
      fingerprint: fingerprint.value,
      activationMetadata: {
        RestrictedMode: "true"
      }
    };

    /**
     *  add MACAddress to activationMetadata if fingerprint is not used
     */
    if (!state.form.isFingerprint) {
      payload.activationMetadata = {
        ...payload.activationMetadata,
        // @ts-ignore
        MACAddress: state.form.mac.trim()
      };
    }
    const response = await callGenerateOfflineCertificate(payload);

    // @ts-ignore
    if (response.data.certificate) {
      $emit("add");
      // @ts-ignore
      state.response = response.data;
    }
  } catch (error) {
    console.log(error);
    state.form.error = t(
      "entitlements.addOfflineCertificateModal.form.errors.server"
    );
  }
  state.loading = false;
};

const downloadCertificate = () => {
  const link = document.createElement("a");

  // @ts-ignore
  const data = state.response.certificate;

  const blob = new Blob([data], { type: "application/octet-stream" });

  const url = URL.createObjectURL(blob);

  link.href = url;
  link.download = "DTS_activation.bin";
  link.click();

  URL.revokeObjectURL(url);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(VaModal), {
      modelValue: _unref(state).isOpen,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_unref(state).isOpen = $event)),
      title: _unref(t)('entitlements.addOfflineCertificateModal.title'),
      "hide-default-actions": ""
    }, {
      default: _withCtx(() => [
        (_unref(state).loading)
          ? (_openBlock(), _createBlock(LoadingSpinner, {
              key: 0,
              class: "loading-spinner",
              style: {"min-height":"10rem"}
            }))
          : _createCommentVNode("", true),
        (!_unref(state).response && !_unref(state).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)("entitlements.addOfflineCertificateModal.explanation")), 1),
              (_unref(state).form.error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(state).form.error), 1))
                : _createCommentVNode("", true),
              _createVNode(_unref(VaInput), {
                modelValue: _unref(state).form.key,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(state).form.key = $event)),
                label: "Key",
                placeholder: "Enter Key",
                type: "text",
                class: "w-full",
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  name: "fingerprint",
                  type: "checkbox",
                  class: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(state).form.isFingerprint = $event))
                }, null, 512), [
                  [_vModelCheckbox, _unref(state).form.isFingerprint]
                ]),
                _hoisted_4
              ]),
              _createVNode(_unref(VaInput), {
                modelValue: _unref(state).form.hostname,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(state).form.hostname = $event)),
                label: "Hostname",
                placeholder: "Enter hostname",
                type: "text"
              }, null, 8, ["modelValue"]),
              (!_unref(state).form.isFingerprint)
                ? (_openBlock(), _createBlock(_unref(VaInput), {
                    key: 1,
                    modelValue: _unref(state).form.mac,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(state).form.mac = $event)),
                    label: "MAC",
                    placeholder: "Enter MAC address",
                    type: "text"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_unref(state).form.isFingerprint)
                ? (_openBlock(), _createBlock(_unref(VaInput), {
                    key: 2,
                    modelValue: _unref(state).form.fingerprint,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(state).form.fingerprint = $event)),
                    label: "Fingerprint",
                    placeholder: "Enter Fingerprint",
                    type: "text"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_unref(state).response && !_unref(state).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)("entitlements.addOfflineCertificateModal.success")), 1),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_unref(t)("entitlements.addOfflineCertificateModal.fingerprint")) + " " + _toDisplayString(_unref(fingerprint)) + " ", 1),
                _createVNode(ButtonClipboardCopy, {
                  field: _ctx.$t('entitlements.addOfflineCertificateModal.fingerprintcopy'),
                  value: _unref(fingerprint)
                }, null, 8, ["field", "value"])
              ]),
              _createVNode(_unref(VaButton), {
                color: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (downloadCertificate())),
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("entitlements.addOfflineCertificateModal.buttons.download")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!_unref(state).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!_unref(state).response)
                ? (_openBlock(), _createBlock(_unref(VaButton), {
                    key: 0,
                    color: "secondary",
                    onClick: closeAndReset
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("entitlements.addOfflineCertificateModal.buttons.cancel")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(state).response)
                ? (_openBlock(), _createBlock(_unref(VaButton), {
                    key: 1,
                    color: "#DC2626",
                    onClick: resetForm
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("entitlements.addOfflineCertificateModal.buttons.reset")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(state).response)
                ? (_openBlock(), _createBlock(_unref(VaButton), {
                    key: 2,
                    onClick: generateOfflineCertificate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("entitlements.addOfflineCertificateModal.buttons.add")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(state).response)
                ? (_openBlock(), _createBlock(_unref(VaButton), {
                    key: 3,
                    color: "secondary",
                    onClick: closeAndReset
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("entitlements.addOfflineCertificateModal.buttons.finish")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    (_unref(allowOfflineActivation))
      ? (_openBlock(), _createBlock(_unref(VaButton), {
          key: 0,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(state).isOpen = true)),
          class: "flex m-auto"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("entitlements.addOfflineCertificateModal.title")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})